import { ContainerComponent, wrap, Wrapper } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import {  SecondaryTextSm } from "atoms"
import { GenericWrapper, DisplaySubtitleDefaultButtonWrapper, Mb1, Mb3, Mb6 } from "wrappers"
import { IconRectangleUploadButton, TextUploaderButton } from 'molecules';
import { UploadingArrowSvg } from "components/icons";
import styled from "styled-components";
import UploadedFileField from '../UploadedFileField';

export const definition = {
  name: 'UploadedFileField',
  controller: Controller,
  initialProps: ({ subtitles }) => ({ subtitles }),
  props: internalState,
  elements: [
    {
      component: wrap(SecondaryTextSm, Mb1),
      name: "Label",
      displayValue: () => "Subtitles (WebVTT)",
      displayState: () => ({ color: "#566F75" })
    },
    {
      component: IconRectangleUploadButton,
      name: 'UploadSubtitleButton',
      renderIf: ({ subtitles }) => subtitles?.length < 1,
      bindings: ({ video }) => ({
        color: "#1DBD6B",
        width: "250px",
        video,
        title: "Upload Subtitles (WebVTT)",
        icon: UploadingArrowSvg({ width: 20, height: 18, color: window?.settings?.primary_color ?? '#1DBD6B' }),
      })
    },
    {
      wrapper: Mb6,
      name: "UploadedSubtitlesWrapper",
      renderIf: ({ subtitles }) => subtitles?.length > 0,
      elements: [
        {
          wrapper: GenericWrapper,
          name: "SubWrapper",
          isListOf: {
            subtitle: ({ subtitles }) => {
              return subtitles ?? []},
          },
          elements: [
            {
              wrapper: DisplaySubtitleDefaultButtonWrapper,
              name: "DisplaySubtitleDefaultButtonWrapper",
              displayState: ({ subtitle, subtitleIndex }) => {
                const uuid = (subtitleIndex === 0) ? null : subtitle?.uuid ?? "";
                return ({ uuid })
              },
              elements: [
                {
                  component: wrap(UploadedFileField, Mb3),
                  name: 'UploadSubtitles',
                  bindings: ({ subtitle }) => ({
                    uuid: subtitle?.uuid ?? "",
                    label: subtitle?.filename ?? "File",
                    is_default: subtitle?.is_default ?? false,
                    width: "100%",
                    title: "Upload Subtitles (WebVTT)",
                  })
                },
              ]
            },
          ],
        },
        {
          component: wrap(TextUploaderButton, Wrapper(styled.div`margin-top: -8px;`)),
          name: "AddMoreSubtitleButton",
          renderIf: ({ subtitles }) => subtitles?.length > 0,
          bindings: ({ subtitles }) => ({
            subtitles,
            small: true,
            fontWeight: "400",
            title: "Add another .vvt subtitle file",
          }),
        },
      ]
    },
  ]
};

export const  SubtitlesUploader = ContainerComponent(definition);
